import { TooltipDesignTokens } from '@primeng/themes/types/tooltip';

export default {
    root: {
        maxWidth: '12.5rem',
        gutter: '0.25rem',
        shadow: '{overlay.popover.shadow}',
        padding: '0.625rem 0.75rem',
        borderRadius: '5px' //changed by mazars
    },
    colorScheme: {
        light: {
            root: {
                background: '#495057', //changed by mazars
                color: '{surface.0}'
            }
        },
        dark: {
            root: {
                background: '{surface.700}',
                color: '{surface.0}'
            }
        }
    }
} as TooltipDesignTokens;
